// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1B6Sg","dragIcon":"SortableItem_dragIcon__1Z3jE","disabled":"SortableItem_disabled__x10v_"};